import { useState } from "react";
import { toast } from "react-toastify";
import { getSnapchatAdAccounts } from "../../../../services/ApiService";

import { useNavigate } from "react-router-dom";

export const SnapchatAdsOrganisationsTable = ({
    organisations,
    setAdAccounts,
    setShowAdAccountsModal,
    setSnapchatUserInfo

}) => {
    const [linking, setlinking] = useState(false);
    const navigate=useNavigate()
    const headers = [
        { label: "Sl.No", key: "sl.no" },
        { label: "Organisation Name", key: "name" },
        { label: "Type", key: "type" },
        { label: "Actions", key: "actions" },
    ];

    const handleConnect = async (organization_id, index) => {
        setlinking((prev) => ({ ...prev, [index]: true })); // Set loading for the specific button
        try {
            const response = await getSnapchatAdAccounts(organization_id);
            if (response?.success) {
                toast.success(response?.message);

                setSnapchatUserInfo((prev)=>
                {
                    return {...prev,organization_id:organization_id}
                })
             
                setAdAccounts(response?.data?.ads_account_list)
                setShowAdAccountsModal(true)
       
            } else {
                toast.error("Error connecting Snapchat Ads Account");
            }
        } catch (error) {
            toast.error("Error connecting Snapchat Ads Account");
        } finally {
            setlinking((prev) => ({ ...prev, [index]: false })); // Stop loading
            navigate('/client/settings/integrations')
        }
    };

    return (
        <div className="card-lg bg-light">
            <div className="table-responsive text-nowrap card-body py-0">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
                    <thead>
                        <tr className="fw-bold text-muted bg-light ">
                            {headers.map((header) => (
                                <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                                    {header.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {organisations?.length === 0 ? (
                            <tr>
                                <td colSpan={headers.length} className="text-center text-muted">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            organisations?.map((organisation, index) => (
                                <tr className="text-muted" key={index}>
                                    <td>{index + 1}</td>
                                    <td>{organisation?.name || "---"}</td>
                                    <td>{organisation?.type || "---"}</td>
                                    <td className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-sm rounded-pill btn-primary d-flex align-items-center justify-content-center"
                                            style={{ width: "150px" }}
                                            onClick={() => handleConnect(organisation?.id, index)}
                                            disabled={linking[index]} // Disable button while loading
                                        >
                                            {linking[index] ? (
                                                <span>Please Wait...</span>
                                            ) : (
                                                <span>View Accounts</span>
                                            )}
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
